<template>
  <div class="need-login">
    <div class="not-login">
      <div class="head img-box">
        <img src="~@/assets/img/default-head.png" alt="" class="img" />
      </div>
      <span class="status">未登录</span>
    </div>
    <a href="javascript:;" @click="wxAuthor" class="webchat-login common-bg"><img class="webchat-logo"
        src="~@/assets/img/webchat-logo.png" />微信登录</a>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Storage from '@/utils/Storage'
import { getCookie } from '@/utils/tools'
import wxApi from '@/utils/wxAuth'

export default {
  name: 'Login',
  computed: {
    ...mapGetters({
      userId: 'userId'
    })
  },
  methods: {
    ...mapMutations({
      updateUserData: 'updateUserData'
    }),
    // 根据code 换用户信息
    async getToken (authorCode) {
      try {
        // authorCode = '0716evS72mB6GL086KQ72cZMS726evS1'
        this.$root.openLoading()
        let { code, data, msg } = await this.$http('/api/login/wx/accesstoken', { code: authorCode || '' }, 'get')
        this.$root.closeLoading()
        if (!(code === '0000' && data)) {
          return this.$toast(msg)
        }
        Storage.save('token', data.accessToken || '')
        Storage.save('userInfo', JSON.stringify(data))
        Storage.save('userId', data.currentMemberId)
        this.updateUserData(data)
        if (data.status === 0) {
          this.$router.push('setUserData.html')
        }
      } catch (error) {
        this.$toast(error)
      }
    },
    wxAuthor () {
      localStorage.removeItem("isExit")
      if (this.userId) {
        return
      }
      Storage.remove('token')
      if (this.$route.query.code) {
        this.getToken(this.$route.query.code)
      } else {
        this.$root.openLoading()
        wxApi.init({
          appid: process.env.VUE_APP_APP_ID, // 正式测试号
          redirectUri: window.location.href
        }).author()
        this.$root.closeLoading()
      }
    }
  },
  mounted () {
    if (localStorage.getItem("isExit") || this.$route.name === "Activity" || this.$route.name === "ActivityInfo") {
      return;
    }
    // 微信回调返回了 code,直接去请求登录接口
    if (!Storage.load('token') && !getCookie('session')) {
      if ( !this.$route.query.code && !window.fetchingToken && !window.initing) {
        this.wxAuthor()
      } else {
        // 有code但是已登录的情况
      }
    }
  }
}
</script>

<style lang="scss">
.need-login {
  padding: 25px 40px;
  .head {
    display: inline-block;
    vertical-align: middle;
    margin-right: 20px;
    width: 115px;
    height: 115px;
    border-radius: 100%;
    overflow: hidden;
  }
  .not-login {
    padding: 60px 20px 0 20px;
  }
  .need-login {
    padding: 7px 40px;
    .status {
      color: #9b9b9b;
    }
  }
  .webchat-login {
    display: block;
    margin-top: 227px;
    padding: 30px;
    color: #fff;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    border-radius: 50px;
  }
  .webchat-logo {
    display: inline-block;
    vertical-align: middle;
    margin-right: 20px;
    width: 36px;
  }
}
</style>
